import React from 'react'

import RecurringCharges from './components/RecurringCharges'
import PendingInvoices from './components/PendingInvoices'
import PaidInvoices from './components/PaidInvoices'
import Account from './components/Account'
import { StripeProvider } from 'react-stripe-elements'

export default function PaymentsTab(props){
  return(
      <StripeProvider apiKey={props.stripe_api_key}>
        <div className="w-100">
          <Account/>
          <RecurringCharges/>
          <PendingInvoices/>
          <PaidInvoices/>
        </div>
      </StripeProvider>
  )
}